import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Event bus service for handling logout-related events. */
@Injectable({
  providedIn: 'root'
})
export class LogoutEventService {
  private logoutSubject = new Subject<void>();

  /**
   * Observable that emits when a logout event occurs.
   */
  logout$ = this.logoutSubject.asObservable();

  /**
   * Emits a logout event to all subscribers.
   */
  emitLogout(): void {
    this.logoutSubject.next();
  }
}
